import React, { useContext, useCallback, useEffect, useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Modal, Paper, Select, Snackbar, Stack, Tooltip, Typography } from "@mui/material";
import { TableFooter } from "@mui/material";
import { TableHead, TableBody } from "@mui/material";
import { TableCell, TableRow, TableContainer } from "@mui/material";
import { TablePagination } from "@mui/material";
import { Search } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

import TablePaginationActions from "../../../Components/Pagination/pagination";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { del, get, post } from "../../../Services/tokenConfig";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { StyledTableCell } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";

import ConfirmDialog from "../../../Components/CustomDialog/customdialog";

import { useLocation } from "react-router-dom";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { IPage2 } from "../../../Interfaces/cadernos/caderno2";
import { boasPraticas, modoproducao, pepac, texturasolo } from "../../../informacao_estatica";
import { Alert } from "../../../Components/Alert/Alert";
import { formatarNumero_ao_digitar, formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import IFAPMap from "./mapa";
import { func_print } from "../../../Func_genericas/func_print";
import { loader } from "../../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import SwapVertIcon from "@mui/icons-material/SwapVert";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);

export default function CaraterizacaoAreas() {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const location = useLocation();

  const is_historico = location.state?.is_historico ?? false;

  const [showNewRow, setShowNewRow] = useState(false);
  const [message, setMessage] = React.useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [openDelete, setOpenDelete] = React.useState(false);

  const [error_parcela_numero, setError_parcela_numero] = useState<boolean>(false);
  const [error_n_sequencia, setError_n_sequencia] = useState<boolean>(false);
  const [error_sub_parcela, setError_sub_parcela] = useState<boolean>(false);
  const [error_area, setError_sarea] = useState<boolean>(false);
  const [error_iqfp, setError_iqfp] = useState<boolean>(false);
  const [error_zona_homogenea, setError_zona_homogenea] = useState<boolean>(false);
  const [error_cultura, setError_cultura] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");
  const message_apenas_numeros_0e5 = ("Apenas números entre 0 e 5 são permitidos.");
  const message_verifique_campos = ("Verifique e preencha todos os campos corretamente.");
  const [message_iqfp, setMessage_iqfp] = useState("");
  const [message_zona_homogenea, setMessage_zona_homogenea] = useState("");

  const [rows, setRows] = useState<IPage2[]>([]);
  const [newRows, setNewRows] = useState<IPage2>();
  const [ordenadoPorZona, setOrdenadoPorZona] = useState(false);
  const [rowsOriginais, setRowsOriginais] = useState<IPage2[]>([]);

  const camposNumericos = ["parcela_numero", "sub_parcela", "area"];

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
  const [open_modal_show_mapa, set_open_modal_show_mapa] = React.useState(false);
  const [dados_about_parcela, set_dados_about_parcela] = useState<any>();
  const [dados_about_parcela_local, set_dados_about_parcela_local] = useState<any>();
  const [dados_about_parcela_centroide, set_dados_about_parcela_centroide] = useState<any>();




  const handleCloseDialog = () => {
    handleCancel()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  /**************** GET DATA **********************************/
  const getCaracterizacao = useCallback(async () => {
    try {
      let res = await get(auth.token.cookie_token, `/get_caraterizacao_id_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {

        const formattedData = res.data.result.map((item: any) => ({
          ...item,
          area: formatarNumero_recebido_com_casa_decimais(item.area),
          // parcela_numero: formatarNumero_recebido_sem_casa_decimais(item.parcela_numero),
          // sub_parcela: formatarNumero_recebido_sem_casa_decimais(item.sub_parcela)
        }));


        setRows(formattedData);
        setRowsOriginais(formattedData);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getCaracterizacao", error, true);
      // setMessage("Erro ao efetuar a sua operação!");
      // setOpenSnackError(true);
      setIsLoading(false);
    }
  }, [auth.token.cookie_token, location.state.id_rosto]);

  useEffect(() => {
    getCaracterizacao();
  }, [getCaracterizacao]);


  const handleCancel = () => {
    setShowNewRow(false);
    setNewRows(undefined);
    setError_parcela_numero(false);
    setError_n_sequencia(false)
    setError_sub_parcela(false);
    setError_sarea(false);
    setError_iqfp(false);
    setError_zona_homogenea(false);
  }

  /************************** CREATE ROW *****************************************/
  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    const isCampoNumerico = camposNumericos.includes(name);

    if (name === "zona_homogenea") {
      if (!/^[a-zA-Z0-9-]+$/.test(value)) {
        setError_zona_homogenea(true);
        if (value.length > 3) {
          setMessage_zona_homogenea("Apenas são permitidas 3 letra. Preencher com '-' se não aplicável.");
        }
      } else {
        setError_zona_homogenea(false);
      }
    } else if (name === "iqfp") {

      if (!/^[0-5]$/.test(value.trim())) {
        setError_iqfp(true);
        setMessage_iqfp(message_apenas_numeros_0e5);
      }

      if (!/^[0-9]*$/.test(value.trim())) {
        setError_iqfp(true);
        setMessage_iqfp("Apenas números são permitidos.");

      }
      const intValue = parseInt(value, 10);
      if ((isNaN(intValue) || intValue < 0 || intValue > 5) || value.trim().length > 1) {
        setError_iqfp(true);
        setMessage_iqfp("Introduza um número entre 0 a 5.");

      } else {
        setError_iqfp(false);
        setMessage_iqfp("");
      }
    } else if (name === "area") {
      if (!/^[0-9,.]*$/.test(value)) {
        setError_sarea(true);
      } else {
        setError_sarea(false);
      }
    } else if (name === "cultura") {
      if (value.trim() === "") {
        setError_cultura(true);
      } else {
        setError_cultura(false);
      }
    }

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "parcela_numero") {
          setError_parcela_numero(false);
        } else if (name === "sub_parcela") {
          setError_sub_parcela(false);
        } else if (name === "area") {
          setError_sarea(false);
        } else if (name === "n_sequencia") {
          setError_n_sequencia(false);
        }


      } else {
        if (name === "parcela_numero") {
          setError_parcela_numero(true);
        } else if (name === "sub_parcela") {
          setError_sub_parcela(true);
        } else if (name === "area") {
          setError_sarea(true);
        } else if (name === "n_sequencia") {
          setError_n_sequencia(true);
        }
      }
      setNewRows((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: formatarNumero_ao_digitar(valorSemFormatar),
      }));
    } else {
      setNewRows((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }

  };

  // const handleCreateRow = async () => {
  //   if (
  //     newRows?.area === undefined || newRows?.area === "" ||
  //     newRows?.zona_homogenea === undefined || newRows?.zona_homogenea === "" ||
  //     newRows?.sub_parcela === undefined || newRows?.sub_parcela === "" ||
  //     newRows?.parcela_numero === undefined || newRows?.parcela_numero === "" ||
  //     newRows?.iqfp === undefined || newRows?.iqfp === "" ||
  //     newRows?.cultura === undefined || newRows?.cultura.trim() === ""
  //   ) {
  //     if (newRows?.area === undefined) {
  //       setError_sarea(true);
  //     }
  //     if (newRows?.zona_homogenea === undefined) {
  //       setMessage_zona_homogenea("Apenas uma letra é permitida. Preencher com '-' se não aplicável.");
  //       setError_zona_homogenea(true);
  //     }
  //     if (newRows?.sub_parcela === undefined) {
  //       setError_sub_parcela(true);
  //     }
  //     if (newRows?.parcela_numero === undefined) {
  //       setError_parcela_numero(true);
  //     }
  //     if (
  //       newRows?.iqfp === undefined ||
  //       newRows?.iqfp.length > 1 ||
  //       parseInt(newRows?.iqfp, 10) < 0 ||
  //       parseInt(newRows?.iqfp, 10) > 5
  //     ) {
  //       setMessage_iqfp("Apenas números entre 0 e 5 são permitidos.");
  //       setError_iqfp(true);
  //     }
  //     if (newRows?.cultura === undefined || newRows?.cultura.trim() === "") {
  //       setError_cultura(true);
  //     }
  //     setMessage("Preencha todos os campos obrigatórios!");
  //     setOpenSnackError(true);
  //     return;
  //   }

  //   if (!/^[a-zA-Z-]$/.test(newRows.zona_homogenea.trim())) {
  //     setError_zona_homogenea(true);
  //     setMessage_zona_homogenea("Apenas uma letra é permitida. Preencher com '-' se não aplicável.");
  //     setMessage(message_verifique_campos);
  //     setOpenSnackError(true);
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
  //     let res = await post(auth.token.cookie_token, "new_caraterizacao", {
  //       payload: {
  //         id_cara: 0,
  //         parcela_numero: newRows?.parcela_numero ? parseInt(newRows.parcela_numero.replace(/\s/g, "").replace(".", "")).toString() : "",
  //         // sub_parcela: newRows?.sub_parcela ? parseInt(newRows.sub_parcela.replace(".", "")).toString() : "",
  //         sub_parcela: newRows?.sub_parcela === undefined ? "" : (formatarNumero_ao_digitar(newRows.sub_parcela).replace(".", "")).toString(),

  //         n_sequencia: newRows?.n_sequencia ? parseInt(newRows.n_sequencia.replace(".", "")) : 0,
  //         nome_parcela: newRows?.nome_parcela || "",
  //         zona_homogenea: newRows?.zona_homogenea || "",
  //         area: newRows?.area ? parseFloat(newRows.area.replace(",", ".")) : "",
  //         textura_solo: newRows?.textura_solo || null,
  //         modo_producao: newRows?.modo_producao || null,
  //         cultura: newRows?.cultura || null,
  //         intervencao_PEPAC: newRows?.intervencao_PEPAC || null,
  //         sucessao_cultural: newRows?.sucessao_cultural || null,
  //         iqfp: newRows?.iqfp || "",
  //         boas_praticas: newRows?.boas_praticas || null,
  //         modificado: true,
  //         id_rosto: location.state.id_rosto,
  //         last_update: new Date().toISOString(),
  //         create_date: new Date().toISOString(),
  //         uuid: "",
  //       },
  //     });

  //     if (res.status === 200) {
  //       setMessage("Gravado com sucesso!");
  //       setOpenSnackSuccess(true);
  //       setShowNewRow(false);
  //       set_flag_editado(false)
  //       setNewRows(undefined);
  //       setRows((prevRows) => [
  //         ...prevRows,
  //         {
  //           ...res.data.result,
  //           area: formatarNumero_recebido_com_casa_decimais(res.data.result.area),
  //           parcela_numero: formatarNumero_recebido_sem_casa_decimais(res.data.result.parcela_numero),
  //           // sub_parcela: formatarNumero_recebido_sem_casa_decimais(res.data.result.sub_parcela),
  //         },
  //       ]);
  //     } else {
  //       setMessage("Erro ao gravar!");
  //       setOpenSnackError(true);
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     func_print("getCaracterizacao", error, true);
  //     setMessage("Erro ao efetuar a sua operação!");
  //     setOpenSnackError(true);
  //     setIsLoading(false);
  //   }
  // };
  const handleCreateRow = async () => {

    if (
      newRows?.iqfp !== undefined &&
      newRows?.iqfp.length > 1 &&
      (parseInt(newRows?.iqfp, 10) < 0 ||
        parseInt(newRows?.iqfp, 10) > 5)
    ) {
      setMessage_iqfp("Apenas números entre 0 e 5 são permitidos.");
      setError_iqfp(true);
    }



    if (newRows?.zona_homogenea !== undefined && (!/^[a-zA-Z0-9-]+$/.test(newRows.zona_homogenea.trim()) || newRows?.zona_homogenea.length > 3)) {
      setError_zona_homogenea(true);
      setMessage_zona_homogenea("Apenas 3 letras são permitidas. Preencher com '-' se não aplicável.");
      setMessage(message_verifique_campos);
      setOpenSnackError(true);
      return;
    }

    try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_caraterizacao", {
        payload: {
          id_cara: 0,
          parcela_numero: newRows?.parcela_numero ? parseInt(newRows.parcela_numero.replace(/\s/g, "").replace(".", "")).toString() : "",
          // sub_parcela: newRows?.sub_parcela ? parseInt(newRows.sub_parcela.replace(".", "")).toString() : "",
          sub_parcela: newRows?.sub_parcela === undefined ? "" : (formatarNumero_ao_digitar(newRows.sub_parcela).replace(".", "")).toString(),

          n_sequencia: newRows?.n_sequencia ? parseInt(newRows.n_sequencia.replace(".", "")) : 0,
          nome_parcela: newRows?.nome_parcela || "",
          zona_homogenea: newRows?.zona_homogenea || "",
          area: newRows?.area ? parseFloat(newRows.area.replace(",", ".")) : 0,
          textura_solo: newRows?.textura_solo || null,
          modo_producao: newRows?.modo_producao || null,
          cultura: newRows?.cultura || null,
          intervencao_PEPAC: newRows?.intervencao_PEPAC || null,
          sucessao_cultural: newRows?.sucessao_cultural || null,
          iqfp: newRows?.iqfp || "",
          boas_praticas: newRows?.boas_praticas || null,
          modificado: true,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        },
      });

      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
        setShowNewRow(false);
        set_flag_editado(false)
        setNewRows(undefined);
        setRows((prevRows) => [
          ...prevRows,
          {
            ...res.data.result,
            area: formatarNumero_recebido_com_casa_decimais(res.data.result.area),
            // parcela_numero: formatarNumero_recebido_sem_casa_decimais(res.data.result.parcela_numero),
            // sub_parcela: formatarNumero_recebido_sem_casa_decimais(res.data.result.sub_parcela),
          },
        ]);
        setRowsOriginais((prevRows) => [
          ...prevRows,
          {
            ...res.data.result,
            area: formatarNumero_recebido_com_casa_decimais(res.data.result.area),
            // parcela_numero: formatarNumero_recebido_sem_casa_decimais(res.data.result.parcela_numero),
            // sub_parcela: formatarNumero_recebido_sem_casa_decimais(res.data.result.sub_parcela),
          },
        ]);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getCaracterizacao", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  /*************** EDITAR LINHA *********************/
  const handleEdit = (obj: IPage2) => {
    handleCancel();
    setError_parcela_numero(false);
    setError_n_sequencia(false);
    setError_sub_parcela(false);
    setError_sarea(false);
    setError_iqfp(false);
    setError_zona_homogenea(false);
    setNewRows(obj);

    setNewRows((prevAzoto: any) => ({
      ...prevAzoto,
      // sub_parcela: formatarNumero_ao_digitar(obj.sub_parcela),


    }));
  };

  const handleUpdateCaraterizacao = async () => {


    if (
      newRows?.iqfp !== undefined &&
      newRows?.iqfp.length > 1 &&
      (parseInt(newRows?.iqfp, 10) < 0 ||
        parseInt(newRows?.iqfp, 10) > 5)
    ) {
      setMessage_iqfp("Apenas números entre 0 e 5 são permitidos.");
      setError_iqfp(true);
    }


    if (newRows?.zona_homogenea?.length !== 0 && newRows?.zona_homogenea !== undefined && (!/^[a-zA-Z0-9-]+$/.test(newRows.zona_homogenea.trim()) || newRows?.zona_homogenea.length > 3)) {
      setError_zona_homogenea(true);
      setMessage_zona_homogenea("Apenas 3 letras são permitidas. Preencher com '-' se não aplicável.");
      setMessage(message_verifique_campos);
      setOpenSnackError(true);
      return;
    }


    try {
      setIsLoading(true);
      const res = await post(auth.token.cookie_token, "/update_caraterizacao", {
        payload: {
          id_cara: newRows?.id_cara,
          parcela_numero: newRows?.parcela_numero === undefined ? "" : parseInt(newRows.parcela_numero.replace(/\s/g, "").replace(".", "")).toString(),
          sub_parcela: newRows?.sub_parcela === undefined ? "" : (formatarNumero_ao_digitar(newRows.sub_parcela).replace(".", "")).toString(),
          n_sequencia: newRows?.n_sequencia ? parseInt(newRows.n_sequencia) : 0,
          zona_homogenea: newRows?.zona_homogenea === undefined ? "" : newRows.zona_homogenea,
          nome_parcela: newRows?.nome_parcela === undefined ? "" : newRows.nome_parcela,
          area: newRows?.area === undefined ? "" : parseFloat(newRows.area.replace(",", ".")),
          textura_solo: newRows?.textura_solo === undefined ? "" : newRows.textura_solo,
          modo_producao: newRows?.modo_producao === undefined ? "" : newRows.modo_producao,
          cultura: newRows?.cultura === undefined ? "" : newRows.cultura,
          intervencao_PEPAC: newRows?.intervencao_PEPAC === undefined ? "" : newRows.intervencao_PEPAC,
          sucessao_cultural: newRows?.sucessao_cultural === undefined ? "" : newRows.sucessao_cultural,
          iqfp: newRows?.iqfp === undefined ? "" : newRows.iqfp,
          boas_praticas: newRows?.boas_praticas === undefined ? "" : newRows.boas_praticas,
          modificado: true,
          id_rosto: location.state.id_rosto,
          last_update: newRows?.last_update,
          create_date: newRows?.create_date,
          uuid: newRows?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");
        setOpenSnackSuccess(true);

        const updatedRows = rows.map((row) => {
          if (row.id_cara === newRows?.id_cara) {
            return {
              ...res.data.result,
              // parcela_numero: formatarNumero_recebido_sem_casa_decimais(res.data.result.parcela_numero),
              // sub_parcela: formatarNumero_recebido_sem_casa_decimais(res.data.result.sub_parcela),
              area: formatarNumero_recebido_com_casa_decimais(res.data.result.area),
            };
          } else {
            return row;
          }
        });
        set_flag_editado(false)

        setRows(updatedRows);
        setRowsOriginais(updatedRows);
        setNewRows(undefined)
      } else {
        setOpenSnackError(true);
        setMessage("Erro ao registar!");
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdateCaraterização", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  };
  // const handleUpdateCaraterizacao = async () => {


  //   if (
  //     newRows?.area === undefined || newRows?.area === "" ||
  //     newRows?.zona_homogenea === undefined || newRows?.zona_homogenea === "" ||
  //     newRows?.sub_parcela === undefined || newRows?.sub_parcela === "" ||
  //     newRows?.parcela_numero === undefined || newRows?.parcela_numero === "" ||
  //     newRows?.iqfp === undefined || newRows?.iqfp === "" ||
  //     newRows?.cultura === undefined || newRows?.cultura === ""
  //   ) {
  //     if (newRows?.area === undefined || newRows?.area === "") {
  //       setError_sarea(true);
  //     }
  //     if (newRows?.zona_homogenea === undefined || newRows?.zona_homogenea === "") {
  //       setMessage_zona_homogenea("Apenas uma letra é permitida. Preencher com '-' se não aplicável.");
  //       setError_zona_homogenea(true);
  //     }
  //     if (newRows?.sub_parcela === undefined || newRows?.sub_parcela === "") {
  //       setError_sub_parcela(true);
  //     }
  //     if (newRows?.parcela_numero === undefined || newRows?.parcela_numero === "") {
  //       setError_parcela_numero(true);
  //     }
  //     if (
  //       newRows?.iqfp === undefined ||
  //       newRows?.iqfp === "" ||
  //       newRows?.iqfp.length > 1 ||
  //       parseInt(newRows?.iqfp, 10) < 0 ||
  //       parseInt(newRows?.iqfp, 10) > 5
  //     ) {
  //       setMessage_iqfp("Apenas números entre 0 e 5 são permitidos.");
  //       setError_iqfp(true);
  //     }
  //     if (newRows?.cultura === undefined || newRows?.cultura === "") {
  //       setError_cultura(true);
  //     }
  //     setMessage("Preencha todos os campos obrigatórios!");
  //     setOpenSnackError(true);
  //     return;
  //   }

  //   if (!/^[a-zA-Z-]$/.test(newRows.zona_homogenea.trim())) {
  //     setError_zona_homogenea(true);
  //     setMessage_zona_homogenea("Apenas uma letra é permitida. Preencher com '-' se não aplicável.");
  //     setMessage(message_verifique_campos);
  //     setOpenSnackError(true);
  //     return;
  //   }


  //   try {
  //     setIsLoading(true);
  //     const res = await post(auth.token.cookie_token, "/update_caraterizacao", {
  //       payload: {
  //         id_cara: newRows?.id_cara,
  //         parcela_numero: newRows?.parcela_numero === undefined ? "" : parseInt(newRows.parcela_numero.replace(/\s/g, "").replace(".", "")).toString(),
  //         sub_parcela: newRows?.sub_parcela === undefined ? "" : (formatarNumero_ao_digitar(newRows.sub_parcela).replace(".", "")).toString(),
  //         n_sequencia: newRows?.n_sequencia ? parseInt(newRows.n_sequencia) : 0,
  //         zona_homogenea: newRows?.zona_homogenea === undefined ? "" : newRows.zona_homogenea,
  //         nome_parcela: newRows?.nome_parcela === undefined ? "" : newRows.nome_parcela,
  //         area: newRows?.area === undefined ? "" : parseFloat(newRows.area.replace(",", ".")),
  //         textura_solo: newRows?.textura_solo === undefined ? "" : newRows.textura_solo,
  //         modo_producao: newRows?.modo_producao === undefined ? "" : newRows.modo_producao,
  //         cultura: newRows?.cultura === undefined ? "" : newRows.cultura,
  //         intervencao_PEPAC: newRows?.intervencao_PEPAC === undefined ? "" : newRows.intervencao_PEPAC,
  //         sucessao_cultural: newRows?.sucessao_cultural === undefined ? "" : newRows.sucessao_cultural,
  //         iqfp: newRows?.iqfp === undefined ? "" : newRows.iqfp,
  //         boas_praticas: newRows?.boas_praticas === undefined ? "" : newRows.boas_praticas,
  //         modificado: true,
  //         id_rosto: location.state.id_rosto,
  //         last_update: newRows?.last_update,
  //         create_date: newRows?.create_date,
  //         uuid: newRows?.uuid,
  //       }
  //     });

  //     if (res.status === 200) {
  //       setMessage("Registado com sucesso!");
  //       setOpenSnackSuccess(true);

  //       const updatedRows = rows.map((row) => {
  //         if (row.id_cara === newRows.id_cara) {
  //           return {
  //             ...res.data.result,
  //             parcela_numero: formatarNumero_recebido_sem_casa_decimais(res.data.result.parcela_numero),
  //             // sub_parcela: formatarNumero_recebido_sem_casa_decimais(res.data.result.sub_parcela),
  //             area: formatarNumero_recebido_com_casa_decimais(res.data.result.area),
  //           };
  //         } else {
  //           return row;
  //         }
  //       });
  //       set_flag_editado(false)

  //       setRows(updatedRows);
  //       setNewRows(undefined)
  //     } else {
  //       setOpenSnackError(true);
  //       setMessage("Erro ao registar!");
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     func_print("handleUpdateCaraterização", error, true);
  //     setMessage("Erro ao gravar!");
  //     setOpenSnackError(true);
  //     setIsLoading(false);
  //   }


  // };

  /************************** DELETE **************************/
  const handleClickOpenDelete = (obj: IPage2) => {
    setOpenDelete(true);
    setNewRows(obj);

  };

  const handleDeleteCaraterizacao = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete_caraterizacao/${newRows?.id_cara}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_cara !== newRows?.id_cara),
        ]);
        setRowsOriginais((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_cara !== newRows?.id_cara),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handleDeleteCaraterizacao", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }


  const get_info_parcela = async (id_parcela: string | undefined) => {
    try {
      let res = await get(auth.token.cookie_token, `/wms/geo/parcela/${id_parcela?.replace(/\s+/g, "")}/geometria`);

      if (res.status === 200) {

        if (res.data.encontrada) {
          let aux_lista_coordenadas = res.data.geometry.coordinates.flat()
          let aux_centroide = Object.values(res.data.centroide)
          set_dados_about_parcela_centroide(aux_centroide)
          set_dados_about_parcela(aux_lista_coordenadas)
          // set_dados_about_parcela(res.data.geometry.coordinates.flat())
          let aux = [
            { Caption: "Numero", Value: res.data.numero_parcela },
            { Caption: "Distrito", Value: res.data.distrito.nome },
            { Caption: "Concelho", Value: res.data.concelho.nome },
            { Caption: "Freguesia", Value: res.data.freguesia.nome },
            { Caption: "Área", Value: (res.data.area_ifap).toString() + 'ha' },
          ];
          set_dados_about_parcela_local(aux)
          set_open_modal_show_mapa(true)
        } else {
          setMessage("Parcela não registada.");
          setOpenSnackError(true);
        }



      }
      setIsLoading(false);
    } catch (error) {
      func_print("get_info_parcela", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }


  const ordenarPorZonaHomogenea = () => {
    if (ordenadoPorZona) {
      setRows([...rowsOriginais]);
      setOrdenadoPorZona(false);
      return;
    }

    const novaLista = [...rowsOriginais].sort((a, b) => {
      const zonaA = a.zona_homogenea?.trim() || "";
      const zonaB = b.zona_homogenea?.trim() || "";

      const aVazio = zonaA === "";
      const bVazio = zonaB === "";

      // os vazios ficam no fim
      if (aVazio && bVazio) return 0;
      if (aVazio) return 1;
      if (bVazio) return -1;

      return zonaA.localeCompare(zonaB, "pt", { sensitivity: "base" });
    });

    setRows(novaLista);
    setOrdenadoPorZona(true);
  };



  /*****************  PAGINAÇÃO ********************** */
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="2 - Caraterização das áreas sob compromisso" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />

          <>
            <Modal
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              open={open_modal_show_mapa}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundColor: 'white',
                width: '40%',
                height: '80%',
                flexDirection: 'column',
                borderRadius: 5,
              }}>
                <div style={{
                  width: '100%',
                  display: "flex",
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  flex: 0.1,
                }}>
                  <Button
                    sx={{ color: "#AAAAAA" }}
                    size="large"
                    onClick={() => {
                      set_open_modal_show_mapa(false)
                    }}
                  >
                    <CloseIcon />
                  </Button>
                </div>
                {
                  isLoading === true ?
                    loader() :
                    <>
                      <div
                        style={{
                          backgroundColor: cores.cor1,
                          display: "flex",
                          alignItems: 'center',
                          justifyContent: 'center',
                          flex: 0.1,
                          fontWeight: 'bold',
                          color: 'white',
                          fontSize: 25,
                          width: '100%',
                          fontFamily: "candara"
                        }}>

                        Registo da Parcela

                      </div>

                      {/* <iframe src="https://publico-isip.ifap.pt/web/Index.aspx?optSearchBy=-900017&txtSearchBy=2+682+422+202+002" ></iframe> */}
                      {/* <a href="https://publico-isip.ifap.pt/web/Index.aspx?optSearchBy=-900017&txtSearchBy=2+682+422+202+002" target="_blank">Abrir consulta</a> */}
                      <IFAPMap latlngs={dados_about_parcela} markerData={dados_about_parcela_local} centroide={dados_about_parcela_centroide} />
                    </>
                }
                {/* <ConfirmDialog
                  open={open_dialog_tem_a_certeza_que_quer_eliminar}
                  onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                  onConfirm={handle_delete_contador}
                  message="Deseja eliminar o registo?"
                /> */}
              </div>



            </Modal>
            <Box width="80%" margin="auto">
              <BeneficiarioNomeIdAlinhadoDireita />
            </Box>

            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            {isLoading ? (
              <LoadingVulpes />
            ) : (
              <TableContainer
                component={Paper}
                variant="outlined"
                sx={{ height: "auto", width: "auto", padding: 2, margin: 2 }}
              >
                <table style={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        sx={{ fontWeight: 700, fontSize: 18, fontFamily: "candara", }}
                      >
                        2 - Caraterização das áreas sob compromisso
                      </TableCell>
                      <TableCell colSpan={4}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            flexWrap: "wrap",
                            gap: 1.5,
                          }}
                        >
                          
                          <Box>
                            {is_historico === true ? null : (
                              <BarraDeFerramentas
                                mostrarBotaoNovo
                                textoBotaoNovo="Novo Registo"
                                aoClicarNovo={() => {
                                  handleCancel();
                                  setShowNewRow(true);
                                }}
                              />
                            )}
                          </Box>


                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead sx={{ minWidth: 125 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Nº Parcela*
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 125 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Nº Seq. de Parcela*
                          <BasicPopover text={" N.º sequencial da parcela - Preencher com o n.º sequencial da parcela constante do iE do agricultor e anexar o respetivo iE. \n\nParcela é a área delimitada geograficamente com uma identificação única conforme registado no Sistema de Identificação Parcelar (iSIP). \n\nO iE é o documento de caraterização da exploração agrícola resultante da identificação das parcelas da exploração no iSIP; \nesta caraterização da exploração encontra-se no documento IFAP e nele consta o n.º sequencial da parcela ou baldio; n.º do parcelário; \nnome da parcela; área da parcela; IQFP, entre outros."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 125 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Nome de Parcela*
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 125 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Subparcela*
                          <BasicPopover text={"Preencher com o n.º de subparcela constante no iE para a corresponde parcela com o n.º sequencial registado na coluna anterior. \n\nEntende-se por Subparcela a área corresponde à porção contínua de terreno homogéneo com a mesma ocupação de solo existente numa mesma parcela e que consta do documento iE"} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead
                        sx={{
                          minWidth: 125,
                          position: "relative",
                          paddingTop: "16px",
                          paddingBottom: "8px",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={0.5}
                          sx={{ textAlign: "center" }}
                        >
                          <span>Zona Homogénea*</span>
                          <BasicPopover text="..." />
                        </Stack>

                        <Tooltip title="Ordenar">
                          <IconButton
                            onClick={ordenarPorZonaHomogenea}
                            size="small"
                            sx={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              color: "#7e2706",
                              padding: "2px",

                              "&:hover": {
                                backgroundColor: "transparent",
                                color: "#c94f1e",
                              },
                            }}
                          >
                            <SwapVertIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </StyledTableHead>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Modo de  Produção
                          <BasicPopover
                            text={" Convencional (CV), \nProdução Integrada (PRODI), \n Manutenção Agricultura Biológica (AB),  \nConversão para AB de 1º ano (C1),\nConversão para AB de 2º ano (C2),\nConversão para AB de 3º ano (C3)."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead width={150}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Intervenção  PEPAC
                          <BasicPopover text={"Agricultura Biológica (AB), \nProdução Integrada (PRODI), \nManeio da pastagem Permanente (MPP), \nPromoção de Fertilização Orgânica (PFO), \nConservação do solo – Sementeira direta (SD), \nConservação do solo – Enrelvamento (ENR), \nConservação do solo – Pastagens biodiversas (PB),\n Uso Eficiente da Água (UEA), \nApoio Zonal Montesinho-Nogueira (AZMN), \nApoio Zonal Douro Internacional, Sabor, Maçãs e Vale do Côa (AZDISMVC), \nAooio Zonal Castro Verde, Vale do Guadiana, Piçarras e Cuba (AZCVVGPC)\n ou Apoio Zonal Alto e Centro Alentejo (AZACA).\n\n Sempre que a mesma subparcela esteja candidata simultaneamente a mais do que uma intervenção PEPAC, o presente campo deve ser preenchido \ncom as siglas de todos os apoios em questão separados por um hifen. EX: AB-ENR-UEA."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead width={150}>Área (ha)* {rows.reduce((acc, row) => {
                        const area = parseFloat((row.area ?? "0").replace(",", "."));
                        return acc + area;
                      }, 0).toFixed(2)}</StyledTableHead>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Textura  do Solo
                          <BasicPopover text={"Exemplos: argiloso (ARG), franco (FRA), arenoso (ARE), franco-argiloso (FAG). A textura ou granulometria refere-se à proporção de argila, limo e areia do solo. Assim, a textura de um solo pode ser observada no respetivo boletim de análises que deve constar em anexo a este CC."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 150 }}>
                        Cultura/ variedade ou casta*
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 150 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Sucessão cultural (C1-C2-C3-C4...)
                          <BasicPopover text={"Preencher apenas nas subparcelas com culturas temporárias. Sucessão de culturas no mesmo ano"} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          IQFP*
                          <BasicPopover text={"O Índice de qualificação fisiográfica da parcela (IQFP) fornece informação sobre o risco de erosão do solo existente nas parcelas. O seu valor varia de 0 a 5 (do menor para o maior declive) e quanto maior for este valor, maior é o risco de perda de solo devido à erosão (de preenchimento facultativo); pode ser consultado no iE."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead width={180}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Boas práticas
                          <BasicPopover text={"Por Boas Práticas Agrícolas (BPA), entende-se o conjunto de princípios, normas e recomendações técnicas. Exemplos: enrelvamento natural ou semeado (ENR), mobilização mínima (M.MÍN), sementeira direta (SEM.D), curvas de nível (C.NÍV), cobertura vegetal do solo (COB), bordaduras ervadas (BORD), bandas de compensação ecológica (BCE), refúgios para fauna selvagem (REF), sebes vegetais (SEB), variedades resistentes (RES), podas de arejamento (P.AR), etc."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead>Ações</StyledTableHead>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showNewRow && (
                      <TableRow>

                        <StyledTableCell>
                          <CustomTextField
                            name="parcela_numero"
                            value={newRows?.parcela_numero === undefined ? "" : newRows?.parcela_numero}
                            onChange={onInputChange}
                            error={error_parcela_numero}
                            helperText={error_parcela_numero ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="n_sequencia"
                            value={newRows?.n_sequencia === undefined ? "" : newRows?.n_sequencia}
                            onChange={onInputChange}
                            error={error_n_sequencia}
                            helperText={error_n_sequencia ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="nome_parcela"
                            value={newRows?.nome_parcela === undefined ? "" : newRows?.nome_parcela}
                            onChange={onInputChange}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="sub_parcela"
                            value={newRows?.sub_parcela === undefined ? "" : newRows.sub_parcela}
                            onChange={onInputChange}
                            error={error_sub_parcela}
                            helperText={error_sub_parcela ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="zona_homogenea"
                            value={newRows?.zona_homogenea === undefined ? "" : newRows.zona_homogenea}
                            onChange={onInputChange}
                            error={error_zona_homogenea}
                            helperText={error_zona_homogenea ? message_zona_homogenea : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomSelect
                            value={newRows?.modo_producao !== undefined ? newRows.modo_producao : ""}
                            name="modo_producao"
                            options={modoproducao}
                            label={"Modo de produção"}
                            onChange={onInputChange}
                            minWidth={120}
                          />
                        </StyledTableCell>
                        <StyledTableCell width={150}>
                          <FormControl>
                            <InputLabel sx={{ fontSize: 14, fontFamily: "candara" }} >
                              Inter. PEPAC
                            </InputLabel>
                            <Select
                              value={newRows?.intervencao_PEPAC ?? []}
                              multiple
                              fullWidth
                              name="intervencao_PEPAC"
                              sx={{ fontSize: 12, fontFamily: "candara", minWidth: 120, }}
                              onChange={onInputChange}
                            >
                              {pepac.map((item) => (
                                <MenuItem key={item} value={item}>
                                  <Typography
                                    style={{ fontSize: 12, fontFamily: "candara", }}>
                                    {item}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="area"
                            value={newRows?.area !== undefined ? newRows.area : ""}
                            onChange={onInputChange}
                            error={error_area}
                            helperText={error_area ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomSelect
                            value={newRows?.textura_solo !== undefined ? newRows.textura_solo : ""}
                            name="textura_solo"
                            label="Textura do solo"
                            options={texturasolo}
                            onChange={onInputChange}
                            minWidth={120}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="cultura"
                            value={newRows?.cultura !== undefined ? newRows.cultura : ""}
                            onChange={onInputChange}
                            error={error_cultura}
                            helperText={error_cultura ? "Preencha este campo" : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="sucessao_cultural"
                            value={newRows?.sucessao_cultural !== undefined ? newRows.sucessao_cultural : ""}
                            onChange={onInputChange}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="iqfp"
                            value={newRows?.iqfp === undefined ? "" : newRows.iqfp}
                            onChange={onInputChange}
                            error={error_iqfp}
                            helperText={error_iqfp ? message_iqfp : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell width={180}>
                          <FormControl>
                            <InputLabel sx={{ fontSize: 14, fontFamily: "candara" }} >
                              Boas prátivas
                            </InputLabel>
                            <Select
                              value={newRows?.boas_praticas ?? []}
                              multiple
                              fullWidth
                              name="boas_praticas"
                              sx={{ fontSize: 12, fontFamily: "candara", minWidth: 120, }}
                              onChange={onInputChange}
                            >
                              {boasPraticas.map((item) => (
                                <MenuItem key={item} value={item}>
                                  <Typography
                                    style={{ fontSize: 12, fontFamily: "candara", }}>
                                    {item}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </StyledTableCell>
                        <StyledTableCell>
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                handleCancel()
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => handleCreateRow()}
                          />
                        </StyledTableCell>
                      </TableRow>
                    )}

                    {(rowsPerPage > 0
                      ? rows.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : rows
                    ).map((row, key) =>
                      <TableRow key={key}>
                        {newRows?.id_cara === row.id_cara ? (
                          <>

                            <StyledTableCell >
                              <CustomTextField
                                name="parcela_numero"
                                error={error_parcela_numero}
                                helperText={error_parcela_numero ? message_apenas_numero : ""}
                                value={newRows?.parcela_numero}
                                onChange={onInputChange} />
                            </StyledTableCell>

                            <StyledTableCell >
                              <CustomTextField
                                name="n_sequencia"
                                error={error_n_sequencia}
                                helperText={error_n_sequencia ? message_apenas_numero : ""}
                                value={newRows?.n_sequencia}
                                onChange={onInputChange} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="nome_parcela"
                                value={newRows?.nome_parcela === undefined ? "" : newRows?.nome_parcela}
                                onChange={onInputChange}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="sub_parcela"
                                error={error_sub_parcela}
                                helperText={error_sub_parcela ? message_apenas_numero : ""}
                                value={newRows?.sub_parcela}
                                onChange={onInputChange} />
                            </StyledTableCell>
                            <StyledTableCell width={50}>
                              <CustomTextField
                                name="zona_homogenea"
                                value={newRows?.zona_homogenea}
                                onChange={onInputChange}
                                error={error_zona_homogenea}
                                helperText={error_zona_homogenea ? message_zona_homogenea : ""} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomSelect
                                value={newRows?.modo_producao !== undefined ? newRows?.modo_producao : ""}
                                name="modo_producao"
                                onChange={onInputChange}
                                options={modoproducao}
                                label="Modo de produção"
                                minWidth={120} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <FormControl>
                                <InputLabel sx={{ fontSize: 14, fontFamily: "candara" }} >
                                  Inter. PEPAC
                                </InputLabel>
                                <Select
                                  value={newRows?.intervencao_PEPAC ?? []}
                                  multiple
                                  fullWidth
                                  name="intervencao_PEPAC"
                                  sx={{ fontSize: 12, fontFamily: "candara", minWidth: 120, }}
                                  onChange={onInputChange}
                                >
                                  {pepac.map((item) => (
                                    <MenuItem key={item} value={item}>
                                      <Typography
                                        style={{ fontSize: 12, fontFamily: "candara", }}>
                                        {item}
                                      </Typography>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </StyledTableCell>
                            <StyledTableCell width={80}>
                              <CustomTextField
                                name="area"
                                value={newRows?.area}
                                error={error_area}
                                helperText={error_area ? message_apenas_numero : ""}
                                onChange={onInputChange} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomSelect
                                value={newRows?.textura_solo !== undefined ? newRows?.textura_solo : ""}
                                label="Textura do solo"
                                name="textura_solo"
                                onChange={onInputChange}
                                options={texturasolo}
                                minWidth={120} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="cultura"
                                value={newRows?.cultura}
                                onChange={onInputChange}
                                error={error_cultura}
                                helperText={error_cultura ? "Preencha este campo" : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="sucessao_cultural"
                                value={newRows?.sucessao_cultural}
                                onChange={onInputChange} />
                            </StyledTableCell>
                            <StyledTableCell width={100}>
                              <CustomTextField
                                name="iqfp"
                                error={error_iqfp}
                                helperText={error_iqfp ? message_iqfp : ""}
                                value={newRows?.iqfp}
                                onChange={onInputChange} />
                            </StyledTableCell>
                            <StyledTableCell width={150}>
                              <FormControl>
                                <InputLabel sx={{ fontSize: 14, fontFamily: "candara" }} >
                                  Boas prátivas
                                </InputLabel>
                                <Select
                                  value={newRows?.boas_praticas ?? []}
                                  multiple
                                  fullWidth
                                  name="boas_praticas"
                                  sx={{ fontSize: 12, fontFamily: "candara", minWidth: 120, }}
                                  onChange={onInputChange}
                                >
                                  {boasPraticas.map((item) => (
                                    <MenuItem key={item} value={item}>
                                      <Typography
                                        style={{ fontSize: 12, fontFamily: "candara", }}>
                                        {item}
                                      </Typography>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </StyledTableCell>
                          </>
                        ) : (
                          row.modificado === false || row.modificado === null ?
                            <>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.parcela_numero}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.n_sequencia}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.nome_parcela}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.sub_parcela} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.zona_homogenea} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.modo_producao}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.intervencao_PEPAC?.join(" - ")}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.area} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.textura_solo} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.cultura} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.sucessao_cultural}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.iqfp} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "red", color: "red" }}> {row.boas_praticas?.join(", ")}</StyledTableCell>
                            </>
                            :
                            <> <StyledTableCell sx={{ borderColor: "green" }}> {row.parcela_numero}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.n_sequencia}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.nome_parcela}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.sub_parcela} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.zona_homogenea} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.modo_producao}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.intervencao_PEPAC?.join(" - ")}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.area} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.textura_solo} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.cultura} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.sucessao_cultural}</StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.iqfp} </StyledTableCell>
                              <StyledTableCell sx={{ borderColor: "green" }}> {row.boas_praticas?.join(", ")}</StyledTableCell>
                            </>
                        )}
                        {newRows?.id_cara === row.id_cara ? (
                          <StyledTableCell>
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => handleUpdateCaraterizacao()}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handleCancel()
                                }
                              }} />
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell>
                            <div style={{
                              display: 'flex',
                              flex: 1,
                            }}>
                              {
                                is_historico === true ? <></> :
                                  <ButtonCadernos
                                    mostrarBotaoEditar
                                    aoClicarEditar={() => handleEdit(row)}
                                    mostrarBotaoApagar
                                    aoClicarApagar={() => handleClickOpenDelete(row)} />
                              }
                              <IconButton
                                sx={{
                                  color: "#7e2706",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#fd0f04",
                                  },
                                }}
                                size="small"
                                onClick={() => {


                                  get_info_parcela(row.parcela_numero)
                                }}

                              >
                                <Search />
                              </IconButton>

                            </div>

                          </StyledTableCell>
                        )}

                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={12} />
                          </TableRow>
                        )}
                      </TableRow>

                    )}
                    <TableRow>
                      <TableCell colSpan={16}>
                        <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                          * Campos de preenchimento obrigatório
                        </Typography>
                        <Typography style={{ fontSize: 14, fontFamily: "candara", color: "green" }}>
                          <span style={{
                            display: "inline-block",
                            width: "12px",
                            height: "2px",
                            backgroundColor: "green",
                            marginRight: "5px"
                          }}></span>
                          Linha editada pelo utilizador
                        </Typography>
                        <Typography style={{ fontSize: 14, fontFamily: "candara", color: "red" }}>
                          <span style={{
                            display: "inline-block",
                            width: "12px",
                            height: "2px",
                            backgroundColor: "red",
                            marginRight: "5px"
                          }}></span>
                          Linha sem edição do utilizador
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <ConfirmDialog
                      open={openDelete}
                      onClose={() => setOpenDelete(false)}
                      onConfirm={handleDeleteCaraterizacao}
                      message="Deseja eliminar o registo?"
                    />
                  </TableBody>
                  <TableFooter>
                    <TableRow sx={{ width: "100%" }}>
                      <TablePagination
                        rowsPerPageOptions={[
                          10,
                          20,
                          40,
                          { label: "Todos", value: -1 },
                        ]}
                        colSpan={12}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelDisplayedRows={({ from, to, count }) => {
                          return `${from}-${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                        }}
                        labelRowsPerPage={'Linhas por página'}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </table>
              </TableContainer>
            )}
          </>
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </main>
      </div>
    </CustomThemeProvider>
  );
}
